<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">新增</el-button>
      <!--      todo 导出-->
      <el-button>导出</el-button>
      <el-button @click.native="handleBatchDelete">批量删除</el-button>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50" fixed/>

        <el-table-column prop="model" label="模式" fixed />
        <el-table-column prop="protocolCode" label="协议代码"/>
        <el-table-column label="日期">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="操作" width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <hardware-form
          :rules="rules"
          :is-edit="isEdit"
          :data="currentRow"
          @confirm="handleAddOrEditSubmit"
          :visible.sync="showDialog"
          :form-items="formConfig" />
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import {exeCommandCopyText} from "@/utils/common";
import HardwareForm from "@/components/hardware/HardwareForm";
import AnkhList from "@/components/list/AnkhList.vue";

// 表单校验
const formRules = {
  model: [
    {required: true, message: '请输入模式', trigger: 'blur'},
  ],
  protocolCode: {required: true, message: '请输入协议代码', trigger: 'change'}
}

export default {
  name: "RecordList",
  components: {AnkhList, HardwareForm, TableList},
  data() {
    return {
      selection: [],
      tableData: [],
      showDialog: false,
      formConfig: [
        {label: "模式", prop: "model", type: "text"},
        {label: "协议代码", prop: "protocolCode", type: "text"},
        {label: "备注", prop: "remark", type: "textarea", rows: 5}
      ],
      rules: Object.freeze(formRules),
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 复制
    handleCopy(row) {
      const flag = exeCommandCopyText(row.protocolCode)
      this.$message({
        type: flag ? 'success' : 'error',
        message: flag ? '复制成功' : '复制失败'
      })
    },

    // 新增\编辑
    async handleAddOrEditSubmit(data) {
      try {
        const action = this.$api.recordModel[this.isEdit ? 'update' : 'add'];
        if(this.isEdit) {
          data = Object.assign(this.currentRow, data);
          delete data.createTime;
          delete data.updateTime;
        }
        await request(action, data);
        this.$message.success("操作成功");
        this.showDialog = false;
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.recordModel.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '未选择记录'
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.recordModel.batchDelete,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest(codes.length);

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.recordModel.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 500px;
  border-radius: 10px;
}
</style>
